import { createSlice } from '@reduxjs/toolkit';
import i18next, { t } from 'i18next';
import { toast } from 'react-toastify';
import { normalizeErrorCode } from 'utils/normalize-error-codes';
import { RootState } from '.';

export type AppNotificationType = {
    interval?: number;
    key: string;
    type: 'error' | 'success' | 'info';
};
export type payloadMessageType = {
    additionalInfo: object;
    interval?: number;
    key: string;
};
export type payloadErrorType = {
    interval?: number;
    key: string;
};
export type payloadSuccessType = {
    interval?: number;
    key: string;
};

const TIME_INTERVAL: { [key: string]: number } = {
    SHORT: 2000,
    MEDIUM: 4000,
    LONG: 6000,
    VERY_LONG: 8000,
};

export const initialState: AppNotificationType = {
    type: 'info',
    key: '',
    interval: TIME_INTERVAL.MEDIUM,
};

const slice = createSlice({
    name: 'message',
    initialState: initialState,
    reducers: {
        resetMessage: () => initialState,

        setErrorMessage: (state, { payload: { interval, key } }: { payload: payloadErrorType }) => {
            state.type = 'error';
            state.key = `ERROR_MESSAGES.${normalizeErrorCode(key)}`;
            if (interval) state.interval = interval;
            toast.error(i18next.t(state.key), { autoClose: state.interval });
        },

        setSuccessMessage: (state, { payload: { interval, key } }: { payload: payloadSuccessType }) => {
            state.type = 'success';
            state.key = `SUCCESS_MESSAGES.${key}`;
            if (interval) state.interval = interval;
            toast.success(i18next.t(state.key), { autoClose: state.interval });
        },

        setInfoMessage: (state, { payload: { additionalInfo, interval, key } }: { payload: payloadMessageType }) => {
            state.type = 'info';
            state.key = t(`InfoMessages.${key}`, { ...additionalInfo });
            if (interval) state.interval = interval;
            toast.info(i18next.t(state.key), { autoClose: state.interval });
        },
    },
});
export const { resetMessage, setErrorMessage, setInfoMessage, setSuccessMessage } = slice.actions;
export default slice.reducer;

export const selectErrorMessage = (state: RootState) => state.toast.key;
